export default __webpack_public_path__ + "static/media/element_spec_66.bfcde4f2.webp";